import { Component, OnInit } from '@angular/core';
export class OpenDayEventsComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-open-day-events',
  template: `
    <p>
      open-day-events works!
    </p>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function OpenDayEventsComponent_tsickle_Closure_declarations() {
/** @type {?} */
OpenDayEventsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OpenDayEventsComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
